export class LoadGlobalServiceMasterList {
  static readonly type = '[Global] Load Service Master List';
}

export class ResetGlobalServiceMasterState {
  static readonly type = '[Global] Reset Service master state';
}
